common.View.create('project::website.modules.projects.Index', {

    map: null,
    infowindow: null,

    onDOMLoad() {
        this.initMap();
    },

    initMap()
    {
        let apiKey = this.element.find('.apiKey').text();

        // Check when script is done loading
        $.getScript('https://maps.googleapis.com/maps/api/js?key='+ apiKey +'&libraries=places&callback=project.website.modules.projects.Index', () => {
            this.setupMap();
        });
    },

    setupMap()
    {
        // Map options
        var options = {
            zoom: 8,
            center: new google.maps.LatLng(51.8920229, 5.1867626),
            styles: this.mapStyling(),
            disableDefaultUI: true,
        };

        // New map
        this.map = new google.maps.Map(document.getElementById('map'), options);

        let locations = JSON.parse(this.element.find('#map').attr('data-locations'));

        // Loop through locations and add marker
        for (let i = 0; i < locations.length; i++) {
            this.addMarker(locations[i], {
                coords: {lat: parseFloat(locations[i].lat), lng: parseFloat(locations[i].lng)}
            });
        }
    },

    mapStyling()
    {
        return [{ "featureType": "all", "elementType": "labels.text.fill", "stylers": [ { "saturation": 36 }, { "color":
        "#333333" }, { "lightness": 40 } ] }, { "featureType": "all", "elementType": "labels.text.stroke",
        "stylers": [ { "visibility": "on" }, { "color": "#ffffff" }, { "lightness": 16 } ] }, { "featureType": "all",
        "elementType": "labels.icon", "stylers": [ { "visibility": "off" } ] }, { "featureType":
        "administrative", "elementType": "geometry.fill", "stylers": [ { "color": "#fefefe" }, { "lightness":
        20 } ] }, { "featureType": "administrative", "elementType": "geometry.stroke", "stylers": [ {
        "color": "#fefefe" }, { "lightness": 17 }, { "weight": 1.2 } ] }, { "featureType":
        "administrative.country", "elementType": "geometry.stroke", "stylers": [ { "visibility": "on" }, {
        "color": "#dddddd" } ] }, { "featureType": "administrative.province", "elementType":
        "labels.text", "stylers": [ { "visibility": "off" }, { "color": "#2b2b2b" } ] }, { "featureType":
        "administrative.locality", "elementType": "labels.text", "stylers": [ { "visibility": "off" } ] }, {
        "featureType": "administrative.land_parcel", "elementType": "labels.text", "stylers": [ {
        "visibility": "off" } ] }, { "featureType": "landscape", "elementType": "geometry", "stylers": [ {
        "color": "#f5f5f5" }, { "lightness": 20 } ] }, { "featureType": "landscape.natural.landcover",
        "elementType": "labels.text", "stylers": [ { "visibility": "off" } ] }, { "featureType":
        "landscape.natural.terrain", "elementType": "labels.text", "stylers": [ { "visibility": "off" } ] }, {
        "featureType": "poi", "elementType": "geometry", "stylers": [ { "color": "#f5f5f5" }, { "lightness":
        21 } ] }, { "featureType": "poi.park", "elementType": "geometry", "stylers": [ { "color":
        "#dedede" }, { "lightness": 21 } ] }, { "featureType": "road.highway", "elementType":
        "geometry.fill", "stylers": [ { "color": "#ffffff" }, { "lightness": 17 } ] }, { "featureType":
        "road.highway", "elementType": "geometry.stroke", "stylers": [ { "color": "#ffffff" }, { "lightness":
        29 }, { "weight": 0.2 } ] }, { "featureType": "road.arterial", "elementType": "geometry", "stylers":
        [ { "color": "#ffffff" }, { "lightness": 18 } ] }, { "featureType": "road.local", "elementType":
        "geometry", "stylers": [ { "color": "#ffffff" }, { "lightness": 16 } ] }, { "featureType": "transit",
        "elementType": "geometry", "stylers": [ { "color": "#f2f2f2" }, { "lightness": 19 } ] }, {
        "featureType": "water", "elementType": "geometry", "stylers": [ { "color": "#e9e9e9" }, {
        "lightness": 17 } ] }, { "featureType": "water", "elementType": "labels.text", "stylers": [ {
        "visibility": "off" } ] } ];
    },

    addMarker(location, props)
    {
        let marker = new google.maps.Marker({
            position: props.coords,
            map: this.map,
            icon: '/img/website/mapIcon.svg',
        });

        // Info Window Content
        var contentString = `
            <div class="min-w-[160px] max-w-lg">
                <img src="` + location.image + `" class="w-full h-36 object-cover" alt="Image Alt Text">
                <div class="bg-white p-6 py-5">
                    <p class="text-primary text-sm">` + (location.subtitle || '') + `</p>
                    <h2 class="text-lg font-semibold mb-2">` + location.title + `</h2>
                    <a href="` + location.link + `" class="inline-block bg-primary text-primary-inverse text-sm px-4 py-2.5 rounded">Ga naar project</a>
                </div>
            </div>`;

        // Add Info Window
        var infowindow = new google.maps.InfoWindow({
            content: contentString,
            disableAutoPan: true
        });

        // Add Listener
        marker.addListener("click", () => {
            infowindow.open(this.map, marker);
        });
    }

});